import {combineReducers} from 'redux';
import uiReducer from 'reducers/uiReducer';
import readyReducer from 'reducers/readyReducer';
import artistsReducer from 'reducers/artistsReducer';
import worksReducer from 'reducers/worksReducer';
import Work from 'types/Work';
import {Artist} from 'types/Artist';

export interface StoreState {
	ui: object,
	works: Work[],
	artists: Artist[],
	ready: boolean
}

const rootReducer = combineReducers({
	ui: uiReducer,
	works: worksReducer,
	artists: artistsReducer,
	ready: readyReducer
});
export default rootReducer;
